import { routes as customer } from './customer'
import { routes as plan } from './plan'

export default [
    ...customer,
    ...plan
]